import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RichTextEditor from 'react-alex-rte'; // this is my package now :eyes:
// Local Deps
import './ComposeMessage.scss';

export default class ComposeMessage extends Component {
  static propTypes = {
    saveDraft: PropTypes.func.isRequired,
    activeDraft: PropTypes.object.isRequired,
    onChangeDraft: PropTypes.func.isRequired,
    customStyling: PropTypes.bool,
  };

  static defaultProps = {
    customStyling: false,
  };
  static initialState = {};

  state = ComposeMessage.initialState;

  onChange = value => {
    if (this.props.onChangeDraft) {
      // Send the changes up to the parent component as an HTML string.
      // This is here to demonstrate using `.toString()` but in a real app it
      // would be better to avoid generating a string on each change.

      this.props.onChangeDraft(value);
      this.props.saveDraft(value.toString('html'));
    }
  };

  render() {
    return (
      <div>
        <RichTextEditor
          type="text"
          className={
            this.props.customStyling
              ? 'compose compose-conversation'
              : 'compose compose-message'
          }
          toolbarOnBottom
          toolbarClassName="compose-message-toolbar"
          editorClassName="compose-message-textarea"
          value={this.props.activeDraft}
          onChange={this.onChange}
          // placeholder="What would you like the banner to say?"
          // onChange={handleChange}
          // onBlur={uploadBanner}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ComposeMessage/ComposeMessage.jsx